import type {TicketDtoStatusEnum} from "@/global/api/gen/ts/TicketDto";
import {Box, Card, CardContent, Stack, Typography} from "@mui/material";
import {TicketStatus} from "@/modules/tickets";

interface Props {
    total: number,
    count: number,
    status: TicketDtoStatusEnum
}

export function StatusCard({total, count, status}: Props) {
    const labelStatus = TicketStatus[status];

    return (
        <Card
            sx={{
                borderRadius: '10px',
                overflow: 'hidden',
                position: "relative",
                backgroundColor: "#F4F7FE",
            }}
        >
            <CardContent
                sx={{
                    height: '100%'
                }}
            >
                <Stack
                    justifyContent={'space-between'}
                    sx={{
                        height: '100%'
                    }}
                >
                    <Typography>
                        {labelStatus.label}
                    </Typography>
                    <Typography
                        fontSize={'37px'}
                        fontWeight={'bold'}
                        sx={{
                            alignSelf: 'end'
                        }}
                    >
                        {count}
                    </Typography>
                </Stack>
            </CardContent>
            <Box
                sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    backgroundColor: labelStatus.color,
                    width: "5px",
                    height: `${count / total * 100}%`,
                }}
            >
            </Box>
        </Card>
    );
}